import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserLoginTest } from 'src/app/layout/inicio-n/login/login.component';
import { environment } from '~environment';
import { UsuarioModel } from '../models/usuario';
import { HttpRequestService } from './HttpRequestService';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  /*
  CODIFICA
    console.log(btoa("SI"));
  DECODIFICA
    console.log(atob("U0k="));
  */

  private readonly url = `${environment.apiTriidyUrlRest}/api/Auth`;
  private readonly apiUrlTest = `${environment.apiTriidyUrlAuthTeam}/api`;
  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;

  private userToken: string;
  private userRole: string;
  private userVersion: string;
  private userProvider: string;
  private idStore: string;
  private userStore: string;
  private userName: string;
  private menu: any;
  private tipo: string;
  private drop: string;

  private userLog: any;

  constructor(private http: HttpClient, private httpRequestService: HttpRequestService) {
    //Con esto sabemos si cuando ingresa existe un token
    this.leerToken();
  }

  logout() {
    sessionStorage.removeItem(btoa('token'));
    sessionStorage.removeItem(btoa('role'));
    sessionStorage.removeItem(btoa('provider'));
    sessionStorage.removeItem(btoa('storeId'));
    sessionStorage.removeItem(btoa('store'));
    sessionStorage.removeItem(btoa('nameUser'));
    sessionStorage.removeItem(btoa('menu'));
    sessionStorage.removeItem(btoa('userLog'));
    sessionStorage.removeItem(btoa('boost'));
    sessionStorage.removeItem(btoa('drop'));
    sessionStorage.removeItem(btoa('tipo'));
    sessionStorage.removeItem(btoa('countrySelected'));
    sessionStorage.removeItem(btoa('countrySelectedName'));
    this.userName = '';
    this.userRole = '';
    this.userStore = '';
    this.userProvider = '';
    this.idStore = '';
    this.menu = '';
    this.userLog = '';
    this.tipo = '';
    this.drop = '';
  }

  login(usuario: UsuarioModel, menu: any) {
    const token = environment.serviceToken;

    const authData = {
      token,
      ...usuario,
    };

    /*
    envia la peticion con los datos y el pipe antes de la respuesta correcta
    guarda el Token en el LocalStorage
    */
    return this.http.post(this.url, authData)
      .pipe(
        map(resp => {
          // console.log(resp);
          if (resp[0].key !== 'Error' && resp[0].key !== 'Activar') {
            this.guardarToken(resp[0].key);
            this.guardarRole(resp[0].rol);
            this.guardarVersion(resp[0].autoriza_v2);
            this.guardarProvider(resp[0].proveedor_dropshipping);
            this.guardaIdTienda(resp[0].id_tienda);
            this.guardaTienda(resp[0].nombre_tienda);
            this.guardaUsuario(resp[0].nombre_usuario);
            this.guardaTriidyDrop(resp[0].usa_triidy_drop);
            this.guardaTipo(resp[0].tipo);
            this.guardaMenu(menu);
            this.guardarUserLog(usuario.usuario);
            sessionStorage.setItem(btoa('countrySelected'), btoa(resp[0].codigo_pais));
            sessionStorage.setItem(btoa('countrySelectedName'), btoa(resp[0].nombre_pais));
            // sessionStorage.setItem(btoa('countrySelected'), btoa('57'));
            // sessionStorage.setItem(btoa('countrySelectedName'), btoa('Colombia'));
            // console.log(resp);
            return resp;
          } else if (resp[0].key === 'Activar') {
            return resp;
          } else {
            throw new Error(resp[0].respuesta);
          }
        }, err => {
          console.warn(err);
        })
      );
  }


  loginTriidyTest(dataUser: UserLoginTest): Observable<any> {
    const token = environment.serviceToken;

    const authData = {
      token,
      ...dataUser,
    };

    return this.http.post<any>(`${this.apiUrlTest}/AuthTriidyTest`, authData).pipe(
      map(
        (resp) => {
          return resp;
        },
        (err: any) => {
          console.warn(err);
        }
      )
    );
  }

  //
  private guardarToken(idToken: string) {
    this.userToken = idToken;
    sessionStorage.setItem(btoa('token'), btoa(idToken));
  }

  private guardarUserLog(userLog: string) {
    this.userLog = userLog;
    sessionStorage.setItem(btoa('userLog'), btoa(userLog));
  }

  private guardarRole(idRole: string) {
    this.userRole = idRole;
    sessionStorage.setItem(btoa('role'), btoa(idRole));
  }
  private guardarVersion(isV2: string) {
    this.userVersion = isV2;
    sessionStorage.setItem(btoa('version'), btoa(isV2));
  }
  private guardarProvider(provider: string) {
    this.userProvider = provider;
    sessionStorage.setItem(btoa('provider'), btoa(provider));
  }

  private guardaIdTienda(store: string) {
    this.idStore = store;
    sessionStorage.setItem(btoa('storeId'), btoa(store));
  }

  private guardaTienda(store: string) {
    this.userStore = store;
    sessionStorage.setItem(btoa('store'), btoa(store));
  }

  private guardaUsuario(user: string) {
    this.userName = user;
    sessionStorage.setItem(btoa('nameUser'), btoa(user));
  }
  private guardaTriidyDrop(drop: string) {
    this.drop = drop;
    sessionStorage.setItem(btoa('drop'), btoa(drop));
  }
  private guardaMenu(menu: string) {
    this.menu = menu;
    sessionStorage.setItem(btoa('menu'), btoa(menu));
  }

  private guardaTipo(tipo: string) {
    this.tipo = tipo;
    sessionStorage.setItem(btoa('tipo'), btoa(tipo));
  }

  leerToken() {
    if (sessionStorage.getItem(btoa('token'))) {
      this.userToken = sessionStorage.getItem(btoa('token'));
    } else {
      this.userToken = '';
    }

    return this.userToken;
  }

  leerRole() {
    if (sessionStorage.getItem(btoa('role'))) {
      this.userRole = sessionStorage.getItem(btoa('role'));
    } else {
      this.userRole = '';
    }

    return this.userRole;
  }

  leerVersion() {
    if (sessionStorage.getItem(btoa('version'))) {
      this.userVersion = sessionStorage.getItem(btoa('version'));
    } else {
      this.userVersion = '';
    }

    return this.userVersion;
  }
  leerProvider() {
    if (sessionStorage.getItem(btoa('provider'))) {
      this.userProvider = sessionStorage.getItem(btoa('provider'));
    } else {
      this.userProvider = '';
    }

    return this.userProvider;
  }

  leerIdTienda() {
    if (sessionStorage.getItem(btoa('storeId'))) {
      this.idStore = sessionStorage.getItem(btoa('storeId'));
    } else {
      this.idStore = '';
    }

    return this.idStore;
  }

  leerTienda() {
    if (sessionStorage.getItem(btoa('store'))) {
      this.userStore = sessionStorage.getItem(btoa('store'));
    } else {
      this.userStore = '';
    }

    return this.userStore;
  }
  leerDrop() {
    if (sessionStorage.getItem(btoa('drop'))) {
      this.drop = sessionStorage.getItem(btoa('drop'));
    } else {
      this.drop = '';
    }

    return this.drop;

  }

  leerNombre() {
    if (sessionStorage.getItem(btoa('nameUser'))) {
      this.userName = sessionStorage.getItem(btoa('nameUser'));
    } else {
      this.userName = '';
    }

    return this.userName;
  }

  leerMenu() {
    if (sessionStorage.getItem(btoa('menu'))) {
      this.menu = sessionStorage.getItem(btoa('menu'));
    } else {
      this.menu = '';
    }

    return this.menu;
  }

  leerTipo() {
    if (sessionStorage.getItem(btoa('tipo'))) {
      this.tipo = sessionStorage.getItem(btoa('tipo'));
    } else {
      this.tipo = '';
    }

    return this.tipo;
  }

  leerUserLog() {
    if (sessionStorage.getItem(btoa('userLog'))) {
      this.userLog = sessionStorage.getItem(btoa('userLog'));
    } else {
      this.userLog = '';
    }

    return this.userLog;
  }

  leerBoost() {
    let boost;
    if (sessionStorage.getItem(btoa('boost'))) {
      boost = sessionStorage.getItem(btoa('boost'));
    } else {
      boost = '';
    }

    return boost;
  }

  estaAutenticado(): boolean {
    if (this.userToken.length < 2) {
      return false;
    }

    return this.userToken.length > 2;
  }

  recuperarPass(usuario: any): Observable<any> {

    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      usuario,
      token,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/RecuperarPassword`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  activarTienda(id_tienda: any): Observable<any> {

    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      id_tienda,
      token,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/ActivarTienda`, {
        params,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }
}
